import * as React from 'react';
import { post } from '../../../model/post';
import { PostItem } from './PostItem';
import Paper from '../../../ui-components/Containers/Paper';
import { Divider } from '@material-ui/core';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: {
    postList: Array<post>,
    deliverPost: (post: post) => void,
    getPost: (id: string) => void;
    deletePost: (id: string) => void;
    navigateTo: (path: string) => void;
    classes: any;
}) => (
        <Paper title='Elenco'>
            {props.postList && props.postList.map(c =>
                <><PostItem
                    classes={props.classes}
                    navigateTo={props.navigateTo}
                    post={c}
                    key={c._id}
                    deliverPost={props.deliverPost}
                    getPost={props.getPost}
                    deletePost={props.deletePost}
                />
                    <Divider />
                </>)}
        </Paper>
    );
